import { create } from 'zustand'

// Lenses remap what the constellation's size/brightness MEAN — one channel at a time.
// Lives in a store because the picker sits in the Control Plane's View tab while the
// canvas that obeys it is GraphView.
export type Lens = 'structure' | 'heat' | 'freshness' | 'confidence'

export const LENS_HINTS: Record<Lens, string> = {
  structure: 'size = connectedness · brightness = score',
  heat: 'size + glow = fresh signals — your unread news as light',
  freshness: 'bright = recently touched · dim = needs attention',
  confidence: 'bright = enrichment certainty · dim = the graph is guessing',
}

interface GraphLensState {
  lens: Lens
  setLens: (lens: Lens) => void
}

export const useGraphLens = create<GraphLensState>((set) => ({
  lens: 'structure',
  setLens: (lens) => set({ lens }),
}))
